{
  "collapse": "Contraer",
  "expand": "Ampliar"
}
